<template>
  <create-dialog
    :title="title"
    @closeModal="$emit('closeModal', false)"
    @validate="validateForm"
    ref="createDialog"
    width="60%"
  >
    <template slot="form">
      <form>
        <div class="row">
          <div class="col-12">
            <fg-input
              type="text"
              :label="`${$t('common_words.name')}: *`"
              v-model="model.name"
              name="common_words.name"
              v-validate="modelValidations.name"
              :error="getError('common_words.name', true)"
              :placeholder="`${$t('common_words.name')}`"
              @input="handleNameInput"
            ></fg-input>
          </div>
          <div class="col-12">
            <select-businesses-component
              ref="selectBusiness"
              :showLoading="true"
              :requiered="true"
              :initialData="businessesInitial"
              @onChange="updateSelectedBusinesses"
              @showHideLoading="showHideLoading"
            />
          </div>
        </div>
      </form>
    </template>
  </create-dialog>
</template>
<script>
import { isset, capitalizeString } from 'src/util/Util';
import MixinDialog from 'src/mixins/mixin-dialog';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinValidations from 'src/mixins/forms/mixin-validations';

export default {
  name: 'edit-or-create-location-inspection',
  mixins: [MixinDialog, MixinForm, MixinLoading, MixinValidations],
  data() {
    return {
      disabledField: false,
      model: {
        name: null,
        businesses_id: [],
        businesses_names: [],
      },
      businessesInitial: [],
      modelValidations: {
        name: {
          required: true,
        },
      },
    };
  },
  props: {
    syncDialog: {
      type: Object,
      default: () => {
        return { create: false, disabledField: false };
      },
    },
  },
  watch: {
    syncDialog(newValue) {
      if (newValue.create) this.openModal('create', newValue.disabledField);
      else this.closeModal('create', newValue.disabledField);
    },
  },
  methods: {
    handleNameInput(value) {
      this.model.name = value ? capitalizeString(value) : value;
    },
    validateForm() {
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (!isset(this.model.businesses_id)) {
            return this.validationInputsRequired('bus-rels');
          } else {
            this.$emit('addEdit', this.model);
          }
        }
      });
    },
    updateSelectedBusinesses(data) {
      const bsSelected = data.associations_ids.concat(data.businesses_ids);
      this.$set(this.model, 'businesses_id', bsSelected);
      this.$set(this.model, 'businesses_names', data.names);
    },
  },
  updated() {
    if (sessionStorage.getItem('editForm')) {
      const editForm = JSON.parse(sessionStorage.getItem('editForm'));
      this.model = {
        ...editForm,
        isEdit: true,
      };
      const { business, businesses } = editForm;
      this.$set(this, 'businessesInitial', businesses ? businesses : business);

      sessionStorage.removeItem('editForm');
    }
  },
};
</script>
